import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getOwaResourceImageUrl } from 'owa-resource-url';
import { Icon } from '@fluentui/react/lib/Icon';
import * as styles from './WeatherIcon.scss';

const iconSvgPrefix = 'SkyCode_';
const UNKNOWN_WEATHER_ICON = 'SkyCode_44';
const MAX_SKYCODE = 83;
const MIN_SKYCODE = 1;

export interface WeatherIconProps {
    skyCode: number;
    skyText: string;
    style?: string;
}

export default observer(function WeatherIcon(props: WeatherIconProps) {
    const { skyCode, skyText, style } = props;

    //set to unknown weather icon if skyCode isn't between 1-83
    const iconClass =
        skyCode >= MIN_SKYCODE && skyCode <= MAX_SKYCODE
            ? iconSvgPrefix + skyCode
            : UNKNOWN_WEATHER_ICON;

    let icon = getOwaResourceImageUrl(`${iconClass}.svg`);

    return (
        <Icon
            className={style ? style : styles.weatherIconFigure}
            iconName={skyText}
            ariaLabel={skyText}
            title={skyText}
            imageProps={{
                shouldFadeIn: false,
                src: icon,
                styles: {
                    root: styles.weatherIcon,
                },
                // image is intentionally larger than its container in order for image to be the right visual size
                width: 32,
                height: 32,
            }}
        />
    );
});
